import {DataLayerModel} from "@merchant-webapp/components";

export class CompleteFormTimeSpentDataLayerModel extends DataLayerModel {
	public static readonly EVENT_NAME: string = "COMPLETE_FORM_TIME_SPENT";
	public completeFormTimeSpentInSeconds: number;
	public constructor(timeSpentInSeconds: number) {
		super(CompleteFormTimeSpentDataLayerModel.EVENT_NAME);
		this.completeFormTimeSpentInSeconds = timeSpentInSeconds;
	}
}